import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { DataList } from "../types";

export function PdfAcademy(props: { dataList: DataList[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "ACADEMY", key: "academy", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.academy_code ?? "-",
    academy: item.academy_name ?? "-",
    description: item.description ?? "-",
  }));

  return <PdfTemplate data={dataMap} column={columns} title="ACADEMY" />;
}
